import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getDefaultLabelName } from '~/services/DefaultLabelNameService';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';
import { IState } from '~/sharedInterfaces/IState';

export interface IThankYouMessage {
  header?: string;
  body?: string;
}

interface IThankYouMessageProps extends IThankYouMessage, IBaseComponent {}

const ThankYouMessage: FC<IThankYouMessageProps> = ({ header, body, componentName }) => {
  const { locale } = useSelector((state: IState) => state.widgetContext);
  const { defaultHeader, defaultBody } = getDefaultLabelName(locale, componentName);

  return (
    <div className="qred-component qred-thankyoumessage">
      <p className="qred-first">
        <span className="qred-first">{header || defaultHeader}</span>
      </p>
      <p className="qred-second">
        <span className="qred-first">{body || defaultBody}</span>
      </p>
    </div>
  );
};

export default ThankYouMessage;
